import { render } from "./VabeneFormsListPage.vue?vue&type=template&id=63cafcf9&scoped=true&ts=true"
import script from "./VabeneFormsListPage.vue?vue&type=script&lang=ts"
export * from "./VabeneFormsListPage.vue?vue&type=script&lang=ts"

import "./VabeneFormsListPage.vue?vue&type=style&index=0&id=63cafcf9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cafcf9"]])

export default __exports__